var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGrid = function SvgGrid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 130.5,
    x2: 130.5,
    y1: 12,
    y2: 490.602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00efd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00acea"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 255.5,
    x2: 255.5,
    xlinkHref: "#a",
    y1: 12,
    y2: 490.602
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 380.5,
    x2: 380.5,
    xlinkHref: "#a",
    y1: 12,
    y2: 490.602
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m172 76h-83a10 10 0 0 0 -10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0 -10-10zm-9 84h-64v-64h64z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m297 76h-83a10 10 0 0 0 -10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0 -10-10zm-9 84h-64v-64h64z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m172 202h-83a10 10 0 0 0 -10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0 -10-10zm-9 83h-64v-63h64z",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m297 202h-83a10 10 0 0 0 -10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0 -10-10zm-9 83h-64v-63h64z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m422 76h-83a10 10 0 0 0 -10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0 -10-10zm-9 84h-64v-64h64z",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m422 202h-83a10 10 0 0 0 -10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0 -10-10zm-9 83h-64v-63h64z",
    fill: "url(#c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m172 332h-83a10 10 0 0 0 -10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0 -10-10zm-9 84h-64v-64h64z",
    fill: "url(#a)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m297 332h-83a10 10 0 0 0 -10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0 -10-10zm-9 84h-64v-64h64z",
    fill: "url(#b)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m422 332h-83a10 10 0 0 0 -10 10v83a10 10 0 0 0 10 10h83a10 10 0 0 0 10-10v-83a10 10 0 0 0 -10-10zm-9 84h-64v-64h64z",
    fill: "url(#c)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grid.0bb79b8c.svg";
export { ForwardRef as ReactComponent };